<template>
	<div class="omapi-dash__stats omapi-card__flex">
		<div class="omapi-dash__stats-heading flex">
			<h5>Quick Stats</h5>
			<div class="flex">
				<core-form-datepicker-input
					v-if="'custom' === dateRange.filter"
					:openImmediate="true"
					align="right"
					:dateRange="dateSelection"
					v-model="dateSelection"
				/>
				<core-dropdown-select align="right" :currentValue="dateText">
					<template v-slot:list>
						<li><a
							href="#"
							@click.prevent="updateStats('7-days')"
							:class="{'current' : '7-days' === dateRange.filter}"
						>
							Last 7 Days
						</a></li>
						<li><a
							href="#"
							@click.prevent="updateStats('30-days')"
							:class="{'current' : '30-days' === dateRange.filter}"
						>
							Last 30 Days
						</a></li>
						<li><a
							href="#"
							@click.prevent="updateStats('custom')"
							:class="{'current' : 'custom' === dateRange.filter}"
						>
							Custom Date Range
						</a></li>
					</template>
				</core-dropdown-select>
			</div>
		</div>
		<common-card size="third" class="omapi-dash__stats-nums">
			<div class='omapi-dash__stats-stat'>{{ impressions }}</div>
			<div class='omapi-dash__stats-desc'>Visitors</div>
		</common-card>
		<common-card size="third" class="omapi-dash__stats-nums">
			<div class='omapi-dash__stats-stat'>{{ conversions }}</div>
			<div class='omapi-dash__stats-desc'>Subscribers / Leads</div>
		</common-card>
		<common-card size="third" class="omapi-dash__stats-nums">
			<div class='omapi-dash__stats-stat'>{{ rate }}%</div>
			<div class='omapi-dash__stats-desc'>Conversion Rate</div>
		</common-card>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
	data () {
		return {
			pickerOpen    : false,
			dateSelection : [],
		}
	},
	watch : {
		dateSelection (newVal) {
			let payload = {
				filter : 'custom',
				preset : false,
				start  : newVal[0],
				end    : newVal[1],
			}
			this.$store.commit('dashboard/updateStats', payload)
			this.$store.dispatch('dashboard/fetch', payload)
		},
	},
	computed : {
		...mapState('dashboard', [ 'dateRange' ]),
		...mapGetters('dashboard', [ 'impressions', 'conversions', 'rate' ]),
		dateText () {
			switch (this.dateRange.filter) {
			case '30-days':
				return 'Last 30 Days'
			case '7-days':
				return 'Last 7 Days'
			case 'custom':
				return 'Custom Date Range'
			}
			return ''
		},
	},
	methods : {
		updateStats (dateRange) {
			if ('custom' === dateRange) {
				this.$store.commit('dashboard/updateStats', {
					filter : 'custom',
					preset : false,
				})
			} else {
				let payload = {
					filter : dateRange,
					preset : true,
					start  : '',
					end    : '',
				}
				// We know what dates to use so we can fetch the stats now
				this.$store.dispatch('dashboard/fetch', payload)
				this.$store.commit('dashboard/updateStats', payload)
			}
		},
	},
}
</script>
